import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";
import { EmployeeTemplate } from "./types";

export const employeeTemplateCreateService = (
  params: Types.EmployeeTemplateCreateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeTemplateListService = (params: {
  page?: number | null;
  limit?: number | null;
  templateId?: string | null;
  templateIds?: string[] | null;
  status?: number | null;
  employeeIds?: number[] | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<EmployeeTemplate>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeeTemplateAssignService = (data: {
  templateId: string;
  employeeIds?: number[];
  empCodes?: string[];
  templateCode: string;
  status: number;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Assign,
    config: {
      requireAuthentication: true,
    },
    data,
  });

export const employeeTemplateAssignTemplatesService = (
  data: Types.EmployeeTemplateAssignTemplatesRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.AssignTemplates,
    config: {
      requireAuthentication: true,
    },
    data,
  });

export const employeeTemplateRemoveTemplatesService = (
  data: Types.EmployeeTemplateRemoveTemplatesRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.RemoveTemplates,
    config: {
      requireAuthentication: true,
    },
    data,
  });

export const employeeTemplateInactiveService = (params: { id: string }) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.Inactive?.replace("{id}", params?.id),
    config: {
      requireAuthentication: true,
    },
  });
export const employeeTemplateActiveService = (params: { id: string }) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.Active?.replace("{id}", params?.id),
    config: {
      requireAuthentication: true,
    },
  });
export const employeeTemplateDeleteService = (params: {
  id: string;
  templateCode: string;
  empCode: string;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.Delete?.replace("{id}", params?.id)
      ?.replace("{templateCode}", params?.templateCode)
      ?.replace("{empCode}", params?.empCode),
    config: {
      requireAuthentication: true,
    },
  });
